module.exports = __webpack_public_path__ + "img/8.f17c7698.png";